<app-menu *ngIf="!menu"></app-menu>
<app-menu-company-orga *ngIf="menu == 'menu-company-orga'"></app-menu-company-orga>
<app-menu-orga *ngIf="menu == 'menu-orga'"></app-menu-orga>